import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "location-wrapper",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectCitySideBar && _ctx.toggleSelectCitySideBar(...args)))
  }, [
    _createElementVNode("div", {
      id: "location",
      class: "location-box",
      style: _normalizeStyle({'background': _ctx.bgColor ? _ctx.bgColor : 'linear-gradient(to right, #feaa51, #fe972a)'})
    }, _toDisplayString(_ctx.locationInfo.city), 5)
  ]))
}